import DailyGuarantee from "./DailyGuarantee";
import ShiftGuarantee from "./ShiftGuarantee";
import WeekendGuarantee from "./WeekendGuarantee";
import WeeklyGuarantee from "./WeeklyGuarante";
import "./style.scss";

function Rule({ type, disabled }) {
	switch (type) {
		case "daily-guarantee":
			return <DailyGuarantee disabled={disabled} />;
		// case "shift-guarantee":
		// 	return <ShiftGuarantee disabled={disabled} />;
		// case "weekend-guarantee":
		// 	return <WeekendGuarantee disabled={disabled} />;
		// case "weekly-guarantee":
		// 	return <WeeklyGuarantee disabled={disabled} />;
		default:
			return null;
			// return <div>Rule {type} is not implemented yet</div>;
	}
}

export default Rule;
